import React, { Fragment } from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType, TDWVer5Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import PC_FREE from '@tencent/docs-design-resources/pc/svg/pc_free_tag.svg';
import PALETTE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/palette_light_24.svg';
import CUSTOM_COLOR_OUTLINE_LIGHT_24 from '@tencent/docs-design-resources/pc/svg/custom_color_outline_light_24.svg';
import { CHANGE_THEME_ICON } from '@src/framework/editor/src/img/pageIndex';

export const config = {
    id: ActionType.CHANGE_THEME,
    content: i18n.t('一键换色'),
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.COLOR_SWITCH,
        action: TDWActionType.THEME_CLICK,
        ver5: TDWVer5Type.TOOLBAR_SOURCE,
    },
    icon: CHANGE_THEME_ICON,
};

export const titleConfig = {
    id: ActionType.COLOR_HANDLER,
    content: i18n.t('颜色处理'),
};

export const beautifyConfig = {
    id: ActionType.CHANGE_THEME_COLOR_TOOLBAR_MORE,
    content: i18n.t('更多配色'),
    icon: PALETTE_ICON,
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_MORE_COLOR,
        ver3: 1,
    },
};

export const customConfig = {
    id: ActionType.CHANGE_THEME_COLOR_TOOLBAR_CUSTOM,
    content: i18n.t('自定义配色'),
    icon: CUSTOM_COLOR_OUTLINE_LIGHT_24,
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.BEAUTIFY_CUSTOM_COLOR,
        ver3: 1,
    },
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        tooltip: config.content,
        content: <Fragment>
            <div>{ config.content }</div>
            <img src={PC_FREE} />
        </Fragment>,
    },
    {
        name: titleConfig.id,
        content: titleConfig.content,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: beautifyConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={beautifyConfig.icon} />,
        text: beautifyConfig.content,
        tooltip: beautifyConfig.content,
    },
    {
        name: customConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={customConfig.icon} />,
        text: customConfig.content,
        tooltip: customConfig.content,
    },
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.content,
        text: config.content,
    },
];
